(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4820],{

/***/ 44604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90171);
var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 125 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _image || (_image = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("image", {
    x: 38,
    y: 31,
    width: 169,
    height: 24,
    xlinkHref: "data:image/png;base64,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",
    transform: "translate(-60 -35)",
    fill: "none",
    fillRule: "evenodd"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgLogo);

/***/ }),

/***/ 16869:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(41906);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; },
/* harmony export */   "MU": function() { return /* binding */ setListener; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
var safeGetLocalStorage = function() {
    try {
        return window === null || window === void 0 ? void 0 : window.localStorage;
    } catch (err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to local storage
        return undefined;
    }
};
var setListener = function(cb) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    window.addEventListener("storage", function(e) {
        cb(e);
    });
};
var setItem = function(key, value) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
};
var getItem = function(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return JSON.parse(string);
};
var removeItem = function(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
};


/***/ }),

/***/ 37175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rV": function() { return /* binding */ getItem; },
  "cl": function() { return /* binding */ removeItem; },
  "LS": function() { return /* binding */ setItem; }
});

// UNUSED EXPORTS: isAvailable

// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/local-storage.js
var local_storage = __webpack_require__(59371);
;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/broadcast-message.js
/* eslint-disable import/prefer-default-export */ 
var broadcastMessageToTabs = function(key, value) {
    (0,local_storage/* setItem */.LS)(key, value);
    (0,local_storage/* removeItem */.cl)(key);
};

;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/session-storage.js

var safeGetSessionStorage = function() {
    try {
        return window === null || window === void 0 ? void 0 : window.sessionStorage;
    } catch (err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to session storage
        return undefined;
    }
};
var isAvailable = function() {
    return !!safeGetSessionStorage();
};
var getItem = function(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return JSON.parse(string);
};
var setItem = function(key, value) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _broadcast = ref.broadcast, broadcast = _broadcast === void 0 ? false : _broadcast;
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
    if (broadcast) {
        broadcastMessageToTabs("BROADCAST", {
            key: key,
            data: value
        });
    }
};
var removeItem = function(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
};


/***/ }),

/***/ 13806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62204);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60628);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38137);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60586);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90171);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24686);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93178);
/* eslint react/button-has-type: "off" */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  align-items: center;\n\n  padding: 8px 14px;\n  border: none;\n  border-radius: 5px;\n\n  color: ",
        ";\n  background-color: ",
        ";\n  box-shadow: 0px 4px 7px -4px rgba(148, 0, 211, 0.6);\n\n  transition: all 0.3s;\n\n  svg {\n    fill: white;\n    margin-right: 8px;\n  }\n\n  :disabled {\n    background-color: ",
        ";\n    box-shadow: none;\n  }\n\n  :hover:enabled {\n    box-shadow: 0px 6px 9px 0px rgba(148, 0, 211, 0.6);\n  }\n\n  a {\n    color: ",
        ";\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, icon = _param.icon, children = _param.children, type = _param.type, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "icon",
        "children",
        "type"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        type: type || "button",
        className: className
    }, rest), {
        children: [
            icon && icon,
            children
        ]
    }));
})(_templateObject(), _colors__WEBPACK_IMPORTED_MODULE_7__/* .White */ .Ej, _colors__WEBPACK_IMPORTED_MODULE_7__/* .Purple */ .Lw, _colors__WEBPACK_IMPORTED_MODULE_7__/* .Lavendar */ .Ge, _colors__WEBPACK_IMPORTED_MODULE_7__/* .White */ .Ej);
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button_Button; }
});

// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(81142);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62204);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(60628);
// EXTERNAL MODULE: ../../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(60586);
// EXTERNAL MODULE: ../../../../../node_modules/react/index.js
var react = __webpack_require__(90171);
// EXTERNAL MODULE: ../../../../design-system/Button/Button.jsx
var Button = __webpack_require__(13806);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(38137);
// EXTERNAL MODULE: ../../../../../node_modules/next/link.js
var next_link = __webpack_require__(68964);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(24686);
;// CONCATENATED MODULE: ../../../../design-system/Button/OutlineButton.jsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n\n  background: none;\n  border: 1px solid rgba(19, 2, 40, 0.8);\n  border-radius: 5px;\n  padding: 8px 18px;\n  white-space: nowrap;\n\n  color: rgba(19, 2, 40, 0.8);\n\n  :hover {\n    text-decoration: none;\n    color: rgba(19, 2, 40, 0.8);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var OutlineButton = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs(function(props) {
    return (0,_object_spread/* default */.Z)({
        as: buttonElement(props.href)
    }, props);
})(_templateObject());
var Link = (0,styled_components_browser_esm/* default */.ZP)(function(_param) {
    var href = _param.href, path = _param.path, children = _param.children, external = _param.external, props = (0,_object_without_properties/* default */.Z)(_param, [
        "href",
        "path",
        "children",
        "external"
    ]);
    if (external) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            href: href
        }, props), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        as: path,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: children
        }))
    });
})(_templateObject1());
var Anchor = styled_components_browser_esm/* default.a */.ZP.a(_templateObject2());
function buttonElement(href) {
    if (href && isUrl(href)) {
        return "a";
    }
    if (href) {
        return Link;
    }
    return "button";
}
function isUrl(value) {
    if (!value) {
        return false;
    }
    return value.startsWith("http");
}
/* harmony default export */ var Button_OutlineButton = (OutlineButton);

// EXTERNAL MODULE: ../../../../design-system/colors.js
var colors = __webpack_require__(93178);
;// CONCATENATED MODULE: ../../../../design-system/Button/SecondaryButton.jsx

function SecondaryButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n\n  white-space: nowrap;\n\n  height: ",
        ";\n  padding: ",
        ";\n\n  background: none;\n  border-radius: 5px;\n  border: none;\n\n  transition: box-shadow 0.24s;\n  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,\n    rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(60, 66, 87, 0.16) 0px 0px 0px 1px,\n    rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,\n    rgba(60, 66, 87, 0.08) 0px 2px 5px 0px;\n\n  :hover {\n    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px,\n      rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px,\n      rgba(60, 66, 87, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,\n      rgba(60, 66, 87, 0.08) 0px 3px 9px 0px,\n      rgba(60, 66, 87, 0.08) 0px 2px 5px 0px;\n  }\n\n  :disabled {\n    opacity: 0.5;\n    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px,\n      rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px,\n      rgba(60, 66, 87, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,\n      rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(60, 66, 87, 0.08) 0px 2px 5px 0px;\n  }\n\n  color: rgba(19, 2, 40, 0.8);\n  font-weight: 600;\n\n  a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  a:hover {\n    color: ",
        ";\n  }\n"
    ]);
    SecondaryButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SecondaryButton = styled_components_browser_esm/* default.button */.ZP.button(SecondaryButton_templateObject(), function(param) {
    var large = param.large;
    return large ? "37px" : "29px";
}, function(param) {
    var large = param.large;
    return large ? "8px 14px" : "0 8px";
}, colors/* Navy */.KX, colors/* Navy */.KX);
/* harmony default export */ var Button_SecondaryButton = (SecondaryButton);

;// CONCATENATED MODULE: ../../../../design-system/Button/SecondaryIconButton.jsx




function SecondaryIconButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    width: 18px;\n    height: 18px;\n\n    margin-right: 2px;\n  }\n"
    ]);
    SecondaryIconButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var SecondaryIconButton = (0,styled_components_browser_esm/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var icon = _param.icon, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(Button_SecondaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            icon,
            children
        ]
    }));
})(SecondaryIconButton_templateObject());
/* harmony default export */ var Button_SecondaryIconButton = (SecondaryIconButton);

;// CONCATENATED MODULE: ../../../../design-system/Button/index.tsx
/* eslint-disable react/jsx-props-no-spreading */ 








var Button_Button = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var primary = _param.primary, outline = _param.outline, icon = _param.icon, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "primary",
        "outline",
        "icon",
        "children"
    ]);
    if (primary) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref
        }, rest), {
            children: children
        }));
    }
    if (outline) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_OutlineButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref
        }, rest), {
            children: children
        }));
    }
    if (icon) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_SecondaryIconButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            icon: icon
        }, rest), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_SecondaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref
    }, rest), {
        children: children
    }));
});


/***/ }),

/***/ 85391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62204);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59371);
/* harmony import */ var _components_common_segment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5721);




var isInternalUser = function isInternalUser() {
    var internalUser = (0,_purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_1__/* .getItem */ .rV)("internal-user");
    if (!internalUser) {
        return false;
    }
    return internalUser.isInternalUser === true;
};
var isKnownBot = function isKnownBot() {
    var BOTS = /(pingdom)|(google)/i;
    return __webpack_require__.g.navigator.userAgent.match(BOTS);
};
var FilterWrapper = {
    identify: function identify(userId, traits, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.identify */ .W.identify(userId, traits, options, callback);
        } else {
            // eslint-disable-next-line no-console
            console.log("INTERNAL USER - Identify: ", userId);
        }
    },
    track: function track(event, properties, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.track */ .W.track(event, properties, options, callback);
        } else {
            // eslint-disable-next-line no-console
            console.log("INTERNAL USER - Track: ", event, properties, options, callback);
        }
    },
    page: function page(category, name, properties, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.page */ .W.page(category, name, properties, options, callback);
        } else {
            // eslint-disable-next-line no-console
            console.log("INTERNAL USER - Page: ", category, name, properties, options, callback);
        }
    }
};
var Analytics = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, FilterWrapper), {
    trackTagScanned: function trackTagScanned(param) {
        var itemId = param.itemId, scannedCode = param.scannedCode, shopCode = param.shopCode;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackTagScanned()");
        }
        if (!scannedCode) {
            throw new Error("No scannedCode provided to Analytics.trackTagScanned()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackTagScanned()");
        }
        FilterWrapper.track("Tag Scanned", {
            itemId: itemId,
            scannedCode: scannedCode,
            shopCode: shopCode
        });
    },
    trackCodeEntered: function trackCodeEntered(param) {
        var enteredCode = param.enteredCode, codeType = param.codeType;
        if (!enteredCode) {
            throw new Error("No enteredCode provided to Analytics.trackCodeEntered()");
        }
        if (!codeType) {
            throw new Error("No codeType provided to Analytics.trackCodeEntered()");
        }
        if (codeType === "tag") {
            FilterWrapper.track("Tag Code Entered", {
                enteredCode: enteredCode
            });
        } else if (codeType === "item") {
            FilterWrapper.track("Shareable Code Entered", {
                enteredCode: enteredCode
            });
        } else if (codeType === "external") {
            FilterWrapper.track("External Shop Code Entered", {
                enteredCode: enteredCode
            });
        }
    },
    trackInstagramLinkFollowed: function trackInstagramLinkFollowed(param) {
        var itemId = param.itemId, shopCode = param.shopCode;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackInstagramLinkFollowed()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackInstagramLinkFollowed()");
        }
        FilterWrapper.track("Instagram Link Followed", {
            itemId: itemId,
            shopCode: shopCode
        });
    },
    trackImageGalleryInteraction: function trackImageGalleryInteraction(param) {
        var itemId = param.itemId;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackImageViewed()");
        }
        FilterWrapper.track("Interacted with Image Gallery", {
            itemId: itemId
        });
    },
    trackProductViewed: function trackProductViewed(param) {
        var itemId = param.itemId, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackProductViewed()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackProductViewed()");
        }
        FilterWrapper.track("Product Viewed", {
            itemId: itemId,
            slug: slug,
            product_id: slug
        });
    },
    trackCheckoutStarted: function trackCheckoutStarted(param) {
        var itemId = param.itemId, shopCode = param.shopCode, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackCheckoutStarted()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackCheckoutStarted()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackCheckoutStarted()");
        }
        FilterWrapper.track("Checkout Started", {
            itemId: itemId,
            shopCode: shopCode,
            slug: slug,
            product_id: slug
        });
    },
    trackOrderSubmitted: function trackOrderSubmitted(param) {
        var itemId = param.itemId, shopCode = param.shopCode, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackOrderSubmitted()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackOrderSubmitted()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackOrderSubmitted()");
        }
        FilterWrapper.track("Order Submitted", {
            itemId: itemId,
            shopCode: shopCode,
            slug: slug
        });
    },
    trackOrderCreated: function trackOrderCreated(param) {
        var orderReference = param.orderReference;
        if (!orderReference) {
            throw new Error("No orderReference provided to Analytics.trackOrderCreated()");
        }
        FilterWrapper.track("Order Created", {
            orderReference: orderReference
        });
    },
    trackOrderFailed: function trackOrderFailed() {
        FilterWrapper.track("Order Failed");
    },
    trackShippingMethodSelected: function trackShippingMethodSelected(param) {
        var shippingOption = param.shippingOption;
        if (!shippingOption) {
            throw new Error("No shippingOption provided to Analytics.trackShippingMethodSelected()");
        }
        FilterWrapper.track("Shipping Method Selected", {
            shippingOption: shippingOption
        });
    },
    trackPaymentMethodSelected: function trackPaymentMethodSelected(param) {
        var paymentMethod = param.paymentMethod;
        if (!paymentMethod) {
            throw new Error("No paymentMethod provided to Analytics.trackPaymentMethodSelected()");
        }
        FilterWrapper.track("Payment Method Selected", {
            paymentMethod: paymentMethod
        });
    },
    trackLearnMoreClicked: function trackLearnMoreClicked() {
        FilterWrapper.track("Learn More Clicked");
    },
    trackLearnMoreModalDismissed: function trackLearnMoreModalDismissed() {
        FilterWrapper.track("Learn More Modal Dismissed");
    },
    trackSizeChanged: function trackSizeChanged(param) {
        var itemId = param.itemId, selectedItemId = param.selectedItemId, slug = param.slug;
        FilterWrapper.track("Size Changed", {
            itemId: itemId,
            selectedItemId: selectedItemId,
            slug: slug
        });
    },
    trackMerchantItemUrlVisit: function trackMerchantItemUrlVisit(param) {
        var source = param.source, itemMerchantUrl = param.itemMerchantUrl;
        FilterWrapper.track("Item Merchant Link Visited", {
            source: source,
            itemMerchantUrl: itemMerchantUrl
        });
    },
    trackTrendingItemSelected: function trackTrendingItemSelected(param) {
        var itemId = param.itemId, slug = param.slug;
        FilterWrapper.track("Trending Item Selected", {
            itemId: itemId,
            slug: slug
        });
    },
    trackTrendingScrolled: function trackTrendingScrolled() {
        FilterWrapper.track("Trending Scrolled");
    },
    trackRetailerModalOpened: function trackRetailerModalOpened() {
        FilterWrapper.track("Retailer Modal Opened");
    },
    trackShareModalOpened: function trackShareModalOpened(param) {
        var itemId = param.itemId, slug = param.slug;
        FilterWrapper.track("Share Modal Opened", {
            itemId: itemId,
            slug: slug
        });
    },
    trackLastSeenProductClicked: function trackLastSeenProductClicked() {
        FilterWrapper.track("Last Seen Product Clicked");
    },
    trackInputChanged: function trackInputChanged(param) {
        var name = param.name;
        if (!name) {
            throw new Error("No name provided to Analytics.trackInputChanged");
        }
        FilterWrapper.track("".concat(name, " Changed"));
    },
    trackSectionExpanded: function trackSectionExpanded(param) {
        var title = param.title;
        if (!title) {
            throw new Error("No title provided to Analytics.trackSectionExpanded");
        }
        FilterWrapper.track("".concat(title, " Expanded"));
    },
    trackShareLinkFollowed: function trackShareLinkFollowed(param) {
        var itemId = param.itemId;
        if (!itemId) {
            throw new Error("No title provided to Analytics.trackShareLinkFollowed");
        }
        FilterWrapper.track("Unique Product Share Link Followed", {
            itemId: itemId
        });
    },
    trackNewsletterSignup: function trackNewsletterSignup() {
        FilterWrapper.track("Newsletter Sign Up");
    },
    trackSuggestClicked: function trackSuggestClicked() {
        FilterWrapper.track("Suggest an Item Clicked");
    },
    trackSuggestionSubmitted: function trackSuggestionSubmitted() {
        FilterWrapper.track("Suggestion Submitted");
    },
    trackExplainerVideoPlayed: function trackExplainerVideoPlayed() {
        FilterWrapper.track("Explainer Video Played");
    },
    trackExplainerVideoPaused: function trackExplainerVideoPaused(param) {
        var timeViewed = param.timeViewed;
        FilterWrapper.track("Explainer Video Paused", {
            timeViewed: timeViewed
        });
    },
    trackUserProgressed: function trackUserProgressed(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserProgressed");
        }
        FilterWrapper.track("User Progressed", {
            pageName: pageName
        });
    },
    trackUserEngagedWithLandingPage: function trackUserEngagedWithLandingPage(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserEngagedWithLandingPage");
        }
        FilterWrapper.track("Engaged With Landing Page", {
            pageName: pageName
        });
    },
    trackSizeGuideClicked: function trackSizeGuideClicked() {
        FilterWrapper.track("Size Guide Clicked");
    },
    trackVisitDemoStoreClicked: function trackVisitDemoStoreClicked() {
        FilterWrapper.track("Visit Demo Store Clicked");
    },
    trackGetInTouchClicked: function trackGetInTouchClicked() {
        FilterWrapper.track("Get In Touch Clicked");
    },
    trackMerchantContactFormSubmitted: function trackMerchantContactFormSubmitted() {
        FilterWrapper.track("Merchant Contact Form Submitted");
    },
    trackStoreSignupReview: function trackStoreSignupReview() {
        FilterWrapper.track("Store Review Form Submitted");
    },
    trackSurveyCTAClick: function trackSurveyCTAClick() {
        FilterWrapper.track("Survey CTA Clicked");
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (Analytics);


/***/ }),

/***/ 73409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78839);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60586);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_session_storage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37175);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11141);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90171);
/* harmony import */ var _client_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85391);
/* harmony import */ var _head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44587);
/* harmony import */ var _page_level_progress_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55187);








var defaultDescription = "Purple Dot lets you sell sooner to shoppers who are willing to wait. Bring products to market faster, test demand or avoid deep discounts.";
var Page = function Page(param) {
    var pageName = param.pageName, title = param.title, _titleSuffix = param.titleSuffix, titleSuffix = _titleSuffix === void 0 ? "Purple Dot" : _titleSuffix, noIndex = param.noIndex, description = param.description, head = param.head, children = param.children;
    useTrackingData(pageName);
    var titleText = "".concat(title).concat(titleSuffix ? " | " : "").concat(titleSuffix);
    var descriptionText = description || defaultDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_page_level_progress_bar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_head__WEBPACK_IMPORTED_MODULE_4__/* .Head */ .F, {
                title: titleText,
                description: descriptionText,
                noIndex: noIndex,
                children: head
            }),
            (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(children, Function) ? children({
                title: titleText,
                description: descriptionText
            }) : children
        ]
    });
};
function useTrackingData(pageName) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        trackPageView(pageName);
    }, [
        pageName,
        router.asPath
    ]);
    // Track when the user navigates away from their first page so we can set up exit rate
    // as a metric in our analytics and ad tools
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var trackUserProgressed = function() {
            if (!(0,_purple_dot_browser_sdk_src_libraries_session_storage__WEBPACK_IMPORTED_MODULE_7__/* .getItem */ .rV)("userProgressed")) {
                _client_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].trackUserProgressed */ .Z.trackUserProgressed(pageName);
            }
            (0,_purple_dot_browser_sdk_src_libraries_session_storage__WEBPACK_IMPORTED_MODULE_7__/* .setItem */ .LS)("userProgressed", true, {
                broadcast: false
            });
            router.events.off("routeChangeComplete", trackUserProgressed);
        };
        router.events.on("routeChangeComplete", trackUserProgressed);
    }, [
        pageName,
        router.events
    ]);
}
function trackPageView(pageName) {
    // By the time Track Page is called title
    // isnt set, setTimout allows the title to be updated
    // https://github.com/zeit/next.js/issues/6025
    setTimeout(function() {
        _client_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].page */ .Z.page(pageName);
    }, 0);
}
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 44587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60586);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94843);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90171);
/* harmony import */ var _config_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43985);
/* harmony import */ var _segment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5721);





var Head = function Head(param) {
    var title = param.title, description = param.description, noIndex = param.noIndex, children = param.children;
    var segmentApiKey = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_config_context__WEBPACK_IMPORTED_MODULE_3__/* .ConfigContext */ .E).segmentApiKey;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "UTF-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                sizes: "180x180",
                href: "/static/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: "/static/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "mask-icon",
                href: "/static/favicon-mask.svg",
                color: "#5bbad5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/static/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/static/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/static/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                crossOrigin: "anonymous",
                src: "https://polyfill.io/v3/polyfill.min.js?features=default,fetch,ResizeObserver"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_segment__WEBPACK_IMPORTED_MODULE_4__/* .SegmentSnippet */ .u, {
                apiKey: segmentApiKey
            }),
            noIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }),
            children
        ]
    });
};


/***/ }),

/***/ 55187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5567);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31898);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35823);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2647);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11141);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31683);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(nprogress__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90171);







var PageLevelProgressBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PageLevelProgressBar, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PageLevelProgressBar);
    function PageLevelProgressBar() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, PageLevelProgressBar);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(PageLevelProgressBar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeStart", function() {
                    return nprogress__WEBPACK_IMPORTED_MODULE_1___default().start();
                });
                next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeComplete", function() {
                    return nprogress__WEBPACK_IMPORTED_MODULE_1___default().done();
                });
                next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeError", function() {
                    return nprogress__WEBPACK_IMPORTED_MODULE_1___default().done();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children;
            }
        }
    ]);
    return PageLevelProgressBar;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (PageLevelProgressBar);


/***/ }),

/***/ 77081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ SCALE_0; },
/* harmony export */   "hT": function() { return /* binding */ SCALE_4; },
/* harmony export */   "tB": function() { return /* binding */ SCALE_NEG_3; },
/* harmony export */   "u4": function() { return /* binding */ SCALE_NEG_1; },
/* harmony export */   "z": function() { return /* binding */ SCALE_2; }
/* harmony export */ });
/* unused harmony exports SCALE_NEG_4, SCALE_NEG_2, SCALE_1, SCALE_3, SCALE_5, SCALE_6, SCALE_7, SCALE_8, SCALE_9, SCALE_10, SCALE_11, SCALE_12, SCALE_13, SCALE_14, SCALE_15 */
// https://www.modularscale.com/?14,18&px&1.618
/* eslint-disable import/no-unused-modules */ var SCALE_NEG_4 = "4px";
var SCALE_NEG_3 = "8px";
var SCALE_NEG_2 = "12px";
var SCALE_NEG_1 = "14px";
var SCALE_0 = "18px";
var SCALE_1 = "23px";
var SCALE_2 = "30px";
var SCALE_3 = "37px";
var SCALE_4 = "47px";
var SCALE_5 = "60px";
var SCALE_6 = "76px";
var SCALE_7 = "96px";
var SCALE_8 = "123px";
var SCALE_9 = "155px";
var SCALE_10 = "200px";
var SCALE_11 = "251px";
var SCALE_12 = "322px";
var SCALE_13 = "406px";
var SCALE_14 = "522px";
var SCALE_15 = "657px";


/***/ }),

/***/ 5721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SegmentWrapper; },
/* harmony export */   "u": function() { return /* binding */ SegmentSnippet; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22130);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60586);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90171);
/* harmony import */ var react_inline_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9049);
/* harmony import */ var react_inline_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_inline_script__WEBPACK_IMPORTED_MODULE_2__);




var SegmentSnippet = function SegmentSnippet(param) {
    var apiKey = param.apiKey;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_inline_script__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: '\n      !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";\n        analytics.load(\''.concat(apiKey, "');\n      }}();\n  ")
    });
};
var SegmentTestWrapper = {
    identify: function identify() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _analytics;
        (_analytics = window.analytics).identify.apply(_analytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        if (window.testAnalytics) {
            var _testAnalytics;
            (_testAnalytics = window.testAnalytics).identify.apply(_testAnalytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        }
    },
    track: function track() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _analytics;
        (_analytics = window.analytics).track.apply(_analytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        if (window.testAnalytics) {
            var _testAnalytics;
            (_testAnalytics = window.testAnalytics).track.apply(_testAnalytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        }
    },
    page: function page() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _analytics;
        (_analytics = window.analytics).page.apply(_analytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        if (window.testAnalytics) {
            var _testAnalytics;
            (_testAnalytics = window.testAnalytics).page.apply(_testAnalytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        }
    }
};
var SegmentWrapper = {
    identify: function identify(userId, traits, options, callback) {
        try {
            SegmentTestWrapper.identify(userId, traits, options, callback);
        } catch (_err) {
        /* ignored */ }
    },
    track: function track(event, properties, options, callback) {
        try {
            SegmentTestWrapper.track(event, properties, options, callback);
        } catch (_err) {
        /* ignored */ }
    },
    page: function page(category, name, properties, options, callback) {
        try {
            SegmentTestWrapper.page(category, name, properties, options, callback);
        } catch (_err) {
        /* ignored */ }
    }
};



/***/ }),

/***/ 41906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _error; }
});

// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(5567);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(31898);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(35823);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(38137);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(2647);
// EXTERNAL MODULE: ../../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(60586);
// EXTERNAL MODULE: ../../../../design-system/Button/index.tsx + 3 modules
var Button = __webpack_require__(236);
// EXTERNAL MODULE: ../../../../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(1652);
// EXTERNAL MODULE: ../../../../../node_modules/react/index.js
var react = __webpack_require__(90171);
// EXTERNAL MODULE: ../../../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(24686);
// EXTERNAL MODULE: ./components/common/base-page.jsx
var base_page = __webpack_require__(73409);
// EXTERNAL MODULE: ./components/common/head.tsx
var head = __webpack_require__(44587);
// EXTERNAL MODULE: ./components/common/scale.js
var scale = __webpack_require__(77081);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(81142);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(60628);
;// CONCATENATED MODULE: ./components/common/text.jsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  text-decoration: ",
        ";\n  line-height: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Text = styled_components_browser_esm/* default.span.attrs */.ZP.span.attrs(function(param) {
    var theme = param.theme, tag = param.tag, fontWeight = param.fontWeight, fontFamily = param.fontFamily, fontSize = param.fontSize, bold = param.bold, light = param.light, disabled = param.disabled, branded = param.branded;
    var pdFontWeight = theme.font.weight.default;
    if (light) {
        pdFontWeight = theme.font.weight.light;
    }
    if (bold) {
        pdFontWeight = theme.font.weight.bold;
    }
    if (fontWeight) {
        pdFontWeight = fontWeight;
    }
    var pdFontFamily = theme.font.family.primary;
    if (branded) {
        pdFontFamily = theme.font.family.branded;
    }
    if (fontFamily) {
        pdFontFamily = fontFamily;
    }
    var pdFontSize = theme.font.size.default;
    if (fontSize) {
        pdFontSize = fontSize;
    }
    var pdColor = theme.color.primary;
    if (disabled) {
        pdColor = theme.color.disabled;
    }
    return {
        as: tag,
        pdFontWeight: pdFontWeight,
        pdFontFamily: pdFontFamily,
        pdFontSize: pdFontSize,
        pdColor: pdColor
    };
})(_templateObject(), function(param) {
    var pdFontSize = param.pdFontSize;
    return pdFontSize;
}, function(param) {
    var pdFontWeight = param.pdFontWeight;
    return pdFontWeight;
}, function(param) {
    var pdFontFamily = param.pdFontFamily;
    return pdFontFamily;
}, function(param) {
    var pdColor = param.pdColor;
    return pdColor;
}, function(param) {
    var centered = param.centered;
    return centered ? "center" : "inherit";
}, function(param) {
    var underline = param.underline;
    return underline ? "underline" : "inherit";
}, function(param) {
    var tag = param.tag;
    return (tag === null || tag === void 0 ? void 0 : tag.match(/h[1-6]/)) ? "1.2em" : "1.5em";
});
var Subtitle = (0,styled_components_browser_esm/* withTheme */.Zz)(function(_param) /*#__PURE__*/ {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    return (0,jsx_runtime.jsx)(Text, (0,_object_spread/* default */.Z)({
        tag: "h4",
        fontSize: theme.font.size.large,
        fontWeight: theme.font.weight.medium
    }, props));
});
var Paragraph = function Paragraph(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, (0,_object_spread/* default */.Z)({
        as: "p"
    }, props));
};

// EXTERNAL MODULE: ./components/merchant-dashboard/Logo.svg
var Logo = __webpack_require__(44604);
;// CONCATENATED MODULE: ./pages/_error.jsx
/* eslint react/no-unescaped-entities: "off" */ 




function _error_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  button {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _error_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  padding-top: 18px;\n  padding-left: 18px;\n  width: 239px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-top: 8rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 72px;\n\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}










var ErrorPage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorPage, _Component);
    var _super = (0,_create_super/* default */.Z)(ErrorPage);
    function ErrorPage() {
        (0,_class_call_check/* default */.Z)(this, ErrorPage);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ErrorPage, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, statusCode = _props.statusCode, errorMessage = _props.errorMessage, application = _props.application, url = _props.url;
                var pageName = "".concat(statusCode || "Client", " Error");
                var displayMessage = "Oops, looks like something went wrong";
                if (statusCode) {
                    if (statusCode === 404 && !errorMessage) {
                        displayMessage = "Not Found";
                    } else if (statusCode < 500) {
                        displayMessage = errorMessage;
                    } else {
                        displayMessage = "Oops, looks like something went wrong - ".concat(statusCode);
                    }
                }
                if (application === "merchant-portal") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MerchantPortalErrorPage, {
                        pageName: pageName,
                        url: url
                    });
                }
                if (application === "embedded") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedErrorPage, {
                        pageName: pageName,
                        displayMessage: displayMessage
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CatchallErrorPage, {
                    pageName: pageName,
                    displayMessage: displayMessage
                });
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var req = param.req, res = param.res, err = param.err;
                var statusCode = (res === null || res === void 0 ? void 0 : res.statusCode) || (err === null || err === void 0 ? void 0 : err.statusCode) || null;
                var errorMessage = err === null || err === void 0 ? void 0 : err.message;
                var url = (req === null || req === void 0 ? void 0 : req.originalUrl) || (window === null || window === void 0 ? void 0 : window.location.pathname);
                var application = applicationFromUrl(url);
                // Normally, render errors are caught and reported in _app.jsx using React
                // error boundaries. However, error boundaries don't work with SSR, and
                // the next place Next.js will call is here, so we report server-side render
                // crashes like this.
                // Because we handle errors originating from Express backend elsewhere, we check
                // that the error has not been handled already.
                // See https://github.com/vercel/next.js/issues/5070
                if (req && err && !err.fromBackend) {
                    esm_exports/* captureException */.Tb(err);
                }
                return {
                    statusCode: statusCode,
                    errorMessage: errorMessage,
                    application: application,
                    url: url
                };
            }
        }
    ]);
    return ErrorPage;
}(react.Component);
function applicationFromUrl(url) {
    if (url.startsWith("/merchant-portal")) {
        return "merchant-portal";
    }
    if (url.startsWith("/embedded")) {
        return "embedded";
    }
    return "other";
}
var MerchantPortalErrorPage = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var className = param.className, pageName = param.pageName, url = param.url;
    var storeId = url.split("/")[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_page/* default */.Z, {
        pageName: pageName,
        title: pageName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLink, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                        style: {
                            height: "100%"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: className,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitle, {
                        centered: true,
                        children: "We're sorry, it looks like something has gone wrong"
                    }),
                    storeId && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        primary: true,
                        style: {
                            marginTop: scale/* SCALE_NEG_1 */.u4
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/merchant-portal/home",
                            children: "Take me back to the dashboard"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SupportMessage, {
                        centered: true,
                        children: [
                            "Can’t find what you’re looking for?",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Contact us:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:support@getpurpledot.com",
                                children: "support@getpurpledot.com"
                            })
                        ]
                    })
                ]
            })
        ]
    });
})(_error_templateObject(), scale/* SCALE_0 */.$y);
var EmbeddedErrorPage = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var pageName = param.pageName, displayMessage = param.displayMessage, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head/* Head */.F, {
                title: pageName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitle, {
                    centered: true,
                    children: displayMessage
                })
            })
        ]
    });
})(_templateObject1());
var CatchallErrorPage = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var pageName = param.pageName, displayMessage = param.displayMessage, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_page/* default */.Z, {
        pageName: pageName,
        title: pageName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLink, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                        style: {
                            height: "100%"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: className,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitle, {
                        centered: true,
                        children: displayMessage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SupportMessage, {
                        centered: true,
                        children: [
                            "Can’t find what you’re looking for?",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Contact us:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:support@getpurpledot.com",
                                children: "support@getpurpledot.com"
                            })
                        ]
                    })
                ]
            })
        ]
    });
})(_templateObject2());
var LogoContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var LogoLink = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var className = param.className, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: icon
    });
})(_templateObject4(), scale/* SCALE_NEG_1 */.u4);
var ErrorTitle = (0,styled_components_browser_esm/* default */.ZP)(Subtitle)(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.color.danger;
});
var SupportMessage = (0,styled_components_browser_esm/* default */.ZP)(Paragraph)(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.color.primary;
});
/* harmony default export */ var _error = (ErrorPage);


/***/ }),

/***/ 81669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


/***/ }),

/***/ 5567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 31898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 2647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(83825);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(81669);
;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0,_assert_this_initialized/* default */.Z)(self);
}

;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 83825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 35823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46859);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 78839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 46859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 31683:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8116,9774,2888,179], function() { return __webpack_exec__(16869); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);